export default __webpack_public_path__ + "static/media/fightSong.2e729b2a.mp3";